<h3 class="title-h3">{{'bookingPayment.title.paymentWithLoterica' | ibeadmin | async}}</h3>

<p>{{'bookingPayment.text.afterClickingOnThe' | ibeadmin | async}} <span class="bold">“{{'bookingPayment.text.confirmBooking' | ibeadmin | async}}”</span>  {{'bookingPayment.text.buttonWillBeRedirected' | ibeadmin | async}}  <span
  class="bold">{{'bookingPayment.text.safetyPay' | ibeadmin | async}}</span> {{'bookingPayment.text.inOrderToReceive' | ibeadmin | async}}</p>
<p>{{'bookingPayment.text.canOnlyBePaidDirectly' | ibeadmin | async}}</p>

<div class="payment-option__conditions-wrapper" [class.has-error]="!(formIsValid$ | async)">
	<div class="payment-option__conditions">
		<app-checkbox-input (change)="INDRA_acceptTermsAndConditionsChange($event)" label="" [class.has-error]="!(formIsValid$ | async)"></app-checkbox-input>
		<span>{{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}} 
			<a class="link" href="javascript:;" (click)="INDRA_handleBookingTicketConditions()" attr.aria-label="{{'bookingPayment.aria.openFare' | ibeadmin | async}}'" role="button">
				{{'bookingPayment.text.fareConditions' | ibeadmin | async}}
			</a> {{'bookingPayment.text.andThe' | ibeadmin | async}} 
			<a class="link link--external" href="javascript:;"
				(click)="INDRA_gotoURL('externalURLs.transportConditions')"
				attr.aria-label="{{'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async}}">
				{{'bookingPayment.text.tncCarriage' | ibeadmin | async}}
			</a>
			<!--{{'bookingPayment.text.andThe' | ibeadmin | async}}
			<a class="link link--external" href="javascript:;"
				(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
				{{'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async}}
			</a>-->
			<ng-container *ngIf="displayCovidTermsAndCondition">
				, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
					{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
				</a>
				{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
			</ng-container>
		</span>
	</div>
</div>
